import { createSelector } from "reselect"
import { RootState } from "./redux-store";

export const getUsersSelector = (state: RootState) => {
    return state.usersPage.users
}

export const getUsers = createSelector( getUsersSelector,
    (users) => {
    return users.filter( u => true);
})

export const getTotalUsersCount = (state: RootState) => {
    return state.usersPage.totalUsersCount
}

export const getPageSize = (state: RootState) => {
    return state.usersPage.pageSize
}

export const getCurrentPage = (state: RootState) => {
    return state.usersPage.currentPage
}

export const getIsFetching = (state: RootState) => {
    return state.usersPage.isFetching
}

export const getFollowingIsProgres = (state: RootState) => {
    return state.usersPage.followingIsProgres
}